export const productShortName = 'Gestione Ambientale — Edizione Docenti';
export const productBrand = 'Gestione Ambientale';
export const productEdition = 'Edizione Docenti';
export const productImage = 'https://cdn.magicpatterns.com/uploads/1vyiDbuuDJV2ECEXwYYSbS/MEGAPACK_GESTIONE.png';
export const productImageAlt =
  'Gestione Ambientale Edizione Docenti: collezione didattica in 6 volumi con 5 risorse bonus, circondata da un mappamondo, contenitori per la raccolta differenziata, una pala eolica e un pannello solare';

export const checkoutUrl = 'https://gestione-ambientale-docenti.impultienda.ar/checkout';

export const price = '€27';
export const priceBefore = '€80';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = '€17';
export const bonusTotalValue = '€85';

export const assurances = ['Pagamento sicuro', 'Accesso immediato', 'Garanzia di 7 giorni'];

export const closingLines = [
  'Basta preparare ogni lezione da zero',
  'Basta spiegare ecosistemi, risorse e inquinamento senza materiali chiari',
  'Basta cercare attività e progetti sparsi su internet',
  "Basta verifiche improvvisate all'ultimo minuto",
  'Basta perdere ore a preparare materiali sulla sostenibilità',
];
